import type Result from 'true-myth/result';

import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import type { CompanyProfile } from './company-profile';
import { companyProfileSchema } from './company-profile';

export type UpdateCompanyProfile = (companyProfile: CompanyProfile) => Promise<Result<CompanyProfile, unknown>>;

export const createUpdateCompanyProfile = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): UpdateCompanyProfile => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return (companyProfile) => {
        return validatingCobrainerApiFetcher.patchJson(companyProfileSchema, {
            pathname: `/company-profile`,
            payload: companyProfile,
        });
    };
};
